<template>
        <div class="categories" v-if="categories && categories.length">
            <p class="title">{{ title }}</p>
            <ul class="main-level">
                <li v-for="(category, key) in categories"
                    :key="key"
                    v-for-callback="{ key: key, array: categories, callback: loopCallback }"
                >
                    <template v-if="category.children.length">
                        <div class="link-wrap" :class="{ active: parseInt(category.id) === parseInt(mainCategory.id) }">
                            <a :href="category.detail_url">
                                {{ category.name }}
                            </a>
                            <span @click="toggle">
                                <img src="/img/icons/arrow-categories.svg" loading="lazy">
                            </span>
                        </div>
                        <ul class="secondary-level">
                            <li v-for="(subCategory, key) in category.children"
                                :key="key"
                            >
                                <template v-if="subCategory.children.length">
                                    <a :href="subCategory.detail_url"
                                       data-deep="2"
                                       :class="{ active: parseInt(subCategory.id) === parseInt(mainCategory.id) }"
                                    >
                                        <img src="/img/icons/list-arrow.svg" loading="lazy">
                                        {{ subCategory.name }}
                                    </a>
                                    <ul class="third-level">
                                        <li v-for="(subSubCategory, key) in subCategory.children"
                                            :key="key"
                                        >
                                            <a :href="subSubCategory.detail_url"
                                               data-deep="3"
                                               :class="{ active: parseInt(subSubCategory.id) === parseInt(mainCategory.id) }"
                                            >
                                                {{ subSubCategory.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    <a :href="subCategory.detail_url"
                                       data-deep="2"
                                       :class="{ active: parseInt(subCategory.id) === parseInt(mainCategory.id) }"
                                    >
                                        <img src="/img/icons/list-arrow.svg" loading="lazy">
                                        {{ subCategory.name }}
                                    </a>
                                </template>
                            </li>
                        </ul>

                    </template>
                    <template v-else>
                        <a :href="category.detail_url">
                            {{ category.name }}
                        </a>
                    </template>
                </li>
            </ul>
        </div>
</template>

<script>
export default {

    props: [
        'title',
        'mainCategory',
        'categories'
    ],

    setup(props) {

        function toggle(e) {
            e.target.parentElement.classList.toggle('active')
        }

        function loopCallback() {
            let active = document.querySelector('.categories a.active')

            if ( active ) {
                let deep = active.getAttribute('data-deep')

                if ( deep === '2' ) {
                    active.parentElement.parentElement.previousElementSibling.classList.add('active')
                }

                if ( deep === '3' ) {
                    active.parentElement.parentElement.previousElementSibling.classList.add('active')
                    active.parentElement.parentElement.parentElement.parentElement.previousElementSibling.classList.add('active')
                }
            }
        }

        return {
            toggle,
            loopCallback
        }
    }
}
</script>
